// extracted by mini-css-extract-plugin
export var banner = "_j6-0";
export var closeButton = "_j6-2";
export var greenCheckmark = "_j6-3";
export var hereLink = "_j6-4";
export var titleIcon = "_j6-1";